import { NgModule } from '@angular/core';
import { FiAppearanceStartPageEditModule } from './edit/edit.module';
import { UtilitiesModule } from '../../utilities/utilities.module';
import { CommonModule } from '@angular/common';
import { FiStartPageLayoutModule } from '../../components/start-page-layout/start-page-layout.module';

@NgModule({
    imports: [CommonModule, UtilitiesModule, FiAppearanceStartPageEditModule, FiStartPageLayoutModule],
    declarations: [],
    exports: [FiAppearanceStartPageEditModule],
})
export class FiAppearanceStartPageModule {}
